module.exports = __webpack_public_path__ + "static/media/notification.f67d647a.mp3";